import script from "./bookOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./bookOrder.vue?vue&type=script&setup=true&lang=js"

import "./bookOrder.vue?vue&type=style&index=0&id=197d7f5f&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-197d7f5f"]])

export default __exports__